import type { TourDefinition } from '../tours.types';

export const PROFILE_TOUR: TourDefinition = {
  id: 'profile_help',
  route: '/perfil/perfil',
  remember: true,
  steps: [   
   {
      element: 'body',
      popover: {
        title: 'Tu perfil',
        description: `
          <p>
            Desde aquí administras tu información personal, tus certificados de firma y la seguridad de tu cuenta.
          </p>

          <p>
            Para utilizar la aplicación y realizar procesos de firma, primero debes agregar al menos un
            <strong>certificado digital</strong>.
          </p>

          <div class="tour-warning">
            ⚠️ Sin un certificado no podrás firmar documentos ni iniciar procesos de firma.
          </div>
        `,
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="perfil-datos-title"]',
      popover: {
        title: 'Mis datos',
        description:
          'Edita tu nombre y apellidos. Tu usuario y correo son informativos.',
        side: 'bottom',
        align: 'start',
      },
    },

    {
      element: '[data-tour="perfil-certificados-title"]',
      popover: {
        title: 'Mis certificados',
        description:
          'Aquí gestionas los certificados que utilizas para firmar documentos.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="mi-sello-digital"]',
      popover: {
        title: 'Mi sello digital',
        description:
            'En esta sección puedes configurar la imagen que se utilizará como tu sello digital para firmar documentos.' ,
        side: 'bottom',
        align: 'start',
      },
    },

    
  ],
};
